import {app} from "../../modules/config.ts";

function UiLoader() {
  return (
    <div className="container">
      <div className="splash">
        <img src={`${app.imagePath}/favicon.png`} alt="로고" className="splash-logo" />
      </div>
    </div>
  );
}

export default UiLoader;